
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import Notification from './notify/Notification.vue'
import { getDownloadURL } from '@/util/helpers'
import { useUserStore } from '@/store/user'
import { GlobalActions } from '@/util/enum'
import { useReuseTabStore } from '@/store/reuse-tab'
import { useTokenStore } from '@/store/token'
import SettingDrawer from './setting-drawer/SettingDrawer.vue'

const reuseTabStore = useReuseTabStore()
const tokenStore = useTokenStore()

@Component({
  components: { Notification, SettingDrawer },
})
export default class MainLayoutUser extends Vue {
  @Ref('settingDrawer')
  public settingDrawer!: SettingDrawer
  private useStore = useUserStore()
  private userInfoModal = false

  private getDownloadURL = getDownloadURL

  @Prop({ type: String, default: 'light' })
  private theme!: 'light' | 'dark'

  public toHall() {
    this.$router.push({
      path: '/hall',
    })
  }

  private openSettingDrawer() {
    this.settingDrawer.toggle()
  }

  private logout() {
    this.$confirm({
      content: '是否确认退出',
      onOk: () => {
        reuseTabStore.clear()
        tokenStore.clear()
        this.useStore.logout()
        this.$setGlobalState({
          action: GlobalActions.SignOut,
          userInfo: {},
          token: '',
        })
      },
    })
  }
}
